export default __webpack_public_path__ + "static/media/visaLogo.415a8a58.png";